
// import { io } from 'socket.io-client';

// class SocketService {
//   constructor() {
//     this.socket = null;
//     this.isConnected = false;
//   }

//   connect(url = 'https://propertydealstalk.com', options = {}) {
//     // ✅ Prevent duplicate connections
//     if (this.socket?.connected) {
//       console.log('✅ Socket already connected, ID:', this.socket.id);
//       return Promise.resolve(this.socket);
//     }

//     // ✅ Disconnect existing socket if present but not connected
//     if (this.socket && !this.socket.connected) {
//       console.log('🧹 Cleaning up old socket...');
//       this.socket.removeAllListeners();
//       this.socket.disconnect();
//       this.socket = null;
//     }

//     console.log('🔌 Creating NEW Socket Connection to:', url);

//     const defaultOptions = {
//       transports: ['websocket'],
//       autoConnect: true,
//       reconnection: true,
//       reconnectionAttempts: 5,
//       reconnectionDelay: 500,
//       timeout: 10000,
//       path: '/socket.io/',
//       forceNew: false
//     };

//     this.socket = io(url, { ...defaultOptions, ...options });

//     return new Promise((resolve, reject) => {
//       const timeout = setTimeout(() => {
//         console.error('⏱️ Socket connection timeout');
//         reject(new Error('Socket connection timeout'));
//       }, 12000);

//       this.socket.on('connect', () => {
//         clearTimeout(timeout);
//         console.log('✅ Socket Connected! ID:', this.socket.id);
//         console.log('📡 Transport:', this.socket.io.engine.transport.name);
//         this.isConnected = true;
//         resolve(this.socket);
//       });

//       this.socket.on('connect_error', (error) => {
//         console.error('❌ Connection Error:', error.message);
//         // Don't reject immediately, let reconnection attempts continue
//       });

//       this.socket.on('disconnect', (reason) => {
//         console.log('❌ Socket Disconnected:', reason);
//         this.isConnected = false;
//       });
//     });
//   }

//   emit(eventName, data) {
//     if (!this.socket?.connected) {
//       console.error('❌ Socket not connected, cannot emit:', eventName);
//       return false;
//     }
//     console.log(`📤 Emitting: ${eventName}`, data);
//     this.socket.emit(eventName, data);
//     return true;
//   }

//   on(eventName, handler) {
//     if (!this.socket) {
//       console.error('❌ Socket not initialized');
//       return;
//     }
//     this.socket.on(eventName, handler);
//     console.log(`📥 Registered listener: ${eventName}`);
//   }

//   removeAllListeners(eventName) {
//     if (!this.socket) return;
//     this.socket.removeAllListeners(eventName);
//   }

//   disconnect() {
//     if (!this.socket) return;
//     console.log('🔌 Disconnecting socket...');
//     this.socket.removeAllListeners();
//     this.socket.disconnect();
//     this.socket = null;
//     this.isConnected = false;
//   }

//   getSocket() {
//     return this.socket;
//   }

//   isSocketConnected() {
//     return this.socket?.connected || false;
//   }
// }

// export default new SocketService();



import { io } from 'socket.io-client';

class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.connectionPromise = null;
    this.isReady = false;
    this.isConnecting = false;
    this.emissionQueue = [];
    this.isProcessingQueue = false;
  }

  // ✅ Process emission queue with delays to prevent transport close
  async processEmissionQueue() {
    if (this.isProcessingQueue || this.emissionQueue.length === 0) {
      return;
    }

    this.isProcessingQueue = true;

    while (this.emissionQueue.length > 0) {
      const emission = this.emissionQueue.shift();
      
      if (this.socket?.connected && this.isReady) {
        console.log(`📤 Emitting (queued): ${emission.eventName}`, emission.data);
        this.socket.emit(emission.eventName, emission.data);
        
        // ✅ Wait 250ms between emissions to prevent server overload
        await new Promise(resolve => setTimeout(resolve, 250));
      } else {
        console.warn('⚠️ Socket disconnected, clearing queue');
        this.emissionQueue = [];
        break;
      }
    }

    this.isProcessingQueue = false;
  }

  connect(url = 'https://propertydealstalk.com', options = {}) {
    if (this.connectionPromise || this.isConnecting) {
      console.log('⏳ Connection already in progress, returning existing promise...');
      return this.connectionPromise || Promise.resolve(this.socket);
    }

    if (this.socket?.connected && this.isReady) {
      console.log('✅ Socket already connected, ID:', this.socket.id);
      return Promise.resolve(this.socket);
    }

    if (this.socket && !this.socket.connected) {
      console.log('🧹 Cleaning up old disconnected socket...');
      this.socket.removeAllListeners();
      this.socket.disconnect();
      this.socket = null;
    }

    this.isConnecting = true;
    console.log('🔌 Creating NEW Socket Connection to:', url);

    const defaultOptions = {
      transports: ['websocket', 'polling'],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10000,
      timeout: 30000,
      path: '/socket.io/',
      forceNew: false,
      upgrade: true,
      rememberUpgrade: true,
      withCredentials: false
    };

    this.socket = io(url, { ...defaultOptions, ...options });

    this.connectionPromise = new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        console.error('⏱️ Socket connection timeout (30s)');
        this.connectionPromise = null;
        this.isReady = false;
        this.isConnecting = false;
        reject(new Error('Socket connection timeout'));
      }, 32000);

      this.socket.on('connect', () => {
        clearTimeout(timeout);
        console.log('═══════════════════════════════════');
        console.log('✅ SOCKET CONNECTED SUCCESSFULLY');
        console.log('Socket ID:', this.socket.id);
        console.log('Transport:', this.socket.io.engine.transport.name);
        console.log('═══════════════════════════════════');
        
        this.isConnected = true;
        
        setTimeout(() => {
          this.isReady = true;
          this.connectionPromise = null;
          this.isConnecting = false;
          console.log('✅ Socket is now READY for emissions');
          resolve(this.socket);
        }, 1000);
      });

      this.socket.on('connect_error', (error) => {
        console.error('❌ Connection Error:', error.message);
        console.log('🔄 Will retry connection...');
        this.isReady = false;
      });

      this.socket.on('disconnect', (reason) => {
        console.log('⚠️ Socket Disconnected. Reason:', reason);
        this.isConnected = false;
        this.isReady = false;
        this.connectionPromise = null;
        this.emissionQueue = []; // Clear queue on disconnect

        if (reason === 'io server disconnect') {
          console.log('🔄 Server disconnected socket, reconnecting...');
          setTimeout(() => {
            if (this.socket) {
              this.socket.connect();
            }
          }, 2000);
        }
      });

      this.socket.io.on('reconnect_attempt', (attemptNumber) => {
        console.log(`🔄 Reconnection attempt #${attemptNumber}...`);
        this.isReady = false;
      });

      this.socket.io.on('reconnect', (attemptNumber) => {
        console.log(`✅ Reconnected successfully after ${attemptNumber} attempts`);
        this.isConnected = true;
        
        setTimeout(() => {
          this.isReady = true;
          this.isConnecting = false;
          console.log('✅ Socket ready after reconnection');
        }, 1500);
      });

      this.socket.io.on('reconnect_failed', () => {
        console.error('❌ Reconnection failed after all attempts');
        this.isConnected = false;
        this.isReady = false;
        this.isConnecting = false;
      });

      this.socket.io.on('reconnect_error', (error) => {
        console.error('❌ Reconnection error:', error.message);
        this.isReady = false;
      });

      this.socket.io.engine.on('upgrade', (transport) => {
        console.log('🔼 Transport upgraded to:', transport.name);
      });
    });

    return this.connectionPromise;
  }

  emit(eventName, data) {
    if (!this.socket) {
      console.error('❌ Socket not initialized, cannot emit:', eventName);
      return false;
    }

    if (!this.socket.connected || !this.isReady) {
      console.error('❌ Socket not ready, cannot emit:', eventName);
      console.log(`🔄 Connected: ${this.socket.connected}, Ready: ${this.isReady}`);
      return false;
    }

    // ✅ Add to queue instead of emitting directly
    this.emissionQueue.push({ eventName, data });
    this.processEmissionQueue();
    return true;
  }

  on(eventName, handler) {
    if (!this.socket) {
      console.error('❌ Socket not initialized, cannot listen to:', eventName);
      return;
    }
    this.socket.on(eventName, handler);
    console.log(`📥 Registered listener: ${eventName}`);
  }

  off(eventName, handler) {
    if (!this.socket) return;
    if (handler) {
      this.socket.off(eventName, handler);
    } else {
      this.socket.off(eventName);
    }
  }

  removeAllListeners(eventName) {
    if (!this.socket) return;
    this.socket.removeAllListeners(eventName);
  }

  disconnect() {
    if (!this.socket) {
      console.log('⚠️ No socket to disconnect');
      return;
    }

    console.log('🔌 Manually disconnecting socket...');
    
    this.emissionQueue = [];
    this.isProcessingQueue = false;
    
    this.socket.removeAllListeners();
    
    if (this.socket.io) {
      this.socket.io.removeAllListeners();
    }
    
    this.socket.disconnect();
    
    this.socket = null;
    this.isConnected = false;
    this.isReady = false;
    this.isConnecting = false;
    this.connectionPromise = null;
    
    console.log('✅ Socket disconnected and cleaned up');
  }

  getSocket() {
    return this.socket;
  }

  isSocketConnected() {
    return this.socket?.connected && this.isReady;
  }

  getConnectionState() {
    if (!this.socket) return 'not_initialized';
    if (this.socket.connected && this.isReady) return 'connected';
    if (this.socket.connected && !this.isReady) return 'connecting';
    if (this.socket.disconnected) return 'disconnected';
    return 'connecting';
  }
}

export default new SocketService();
